// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container_23GYx","main":"style-module_main_2arJw","title":"style-module_title_3E30U"};